import React from "react";
import { Header } from "./Introduce";
import styles from "../css/Artisan.css";


const app = () => {
    return (
        <div style={{ flex: 1 }}>
            <Header text="实验室介绍"></Header>
            <div className={styles.main}>
                <p className={styles.title}>
                    专家介绍
                </p>

                <div className={styles.content}>
                    <p className={styles.contentP}>
                        <img src={require("../static/梁琼麟.jpg")}
                            style={{ width: "93px" }} className={styles.img} ></img>
                        <span style={{ "fontWeight": 600 }}>梁琼麟 </span>  
                        ，清华大学长聘教授，教育部长江学者特聘教授，化学系党委书记，清华大学中药现代化研究中心主任，国家中医药管理局中药化学三级实验室主任。2000年和2005年于清华大学化学系先后获得学士和博士学位后留校任教。研究方向为生命与药物分析，近年来重点聚焦于器官类器官芯片、多组学分析及其在精准医学与药学中的应用，包括中药现代化研究。曾主持完成“重大新药创制”国家重大科技专项支持的第一个微流控器官芯片药物研发关键技术项目，主持承担和完成国家自然科学基金项目和国家973子课题、重大科技专项等国家级科研项目二十余项。已取得授权发明专利十余项，发表SCI论文200余篇，被引用6000余次。合作出版研究性专著3部，参（合）编著作2本。部分研究成果已在制药企业、临床医院得到广泛应用，合作获得国家科技进步二等奖3项，以及教育部科技进步一等奖等多项省部级科技成果奖励。积极参与学术服务工作，担任中国医药生物技术协会药物分析技术分会常务委员兼秘书长，中国中药协会中药大品种开发与培育专业委员会副主任委员，北京理化分析测试技术学会副理事长兼青委会理事长，中国分析测试协会青年学术委员会副主任委员，曾作为专家应邀参与国家食品药品安全规划、国家药典附录等重要文件的起草、修订，担任国家药典英文版编委等服务工作。
                    </p>


                </div>

            </div>
        </div>
    );
};

export default app;



// WEBPACK FOOTER //
// ./src/pages/Expert.js